import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { DataChangedService } from 'src/app/data-changed.service';
import { ReportModulesService } from 'src/app/services/report-modules/report-modules.service';

import { RoleBatteryConfig } from 'src/app/modules/role-battery/role-battery.user-settings';

import * as uuid from 'uuid';
import {
  ManagementService,
  SensorsSensor,
  SensorsService,
  TrigonosDatasource,
} from 'src/app/api/generated';

const ROLE_BATTERY_FIELDS = ['dq', 'vroll'];

@Component({
    selector: 'app-role-battery-config-generic',
    templateUrl: './role-battery-config.component.html',
    styleUrls: ['./role-battery-config.component.scss'],
    standalone: false
})
export class GenericRoleBatteryConfigComponent implements OnInit {
  public roleBatteryForm: UntypedFormGroup;
  public availableDataSources: SensorsSensor[] = [];
  public editMode = false;
  public submitting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RoleBatteryConfig,
    private dialogRef: MatDialogRef<RoleBatteryConfig>,
    private formBuilder: UntypedFormBuilder,
    private reportModuleService: ReportModulesService,
    private dataChangedService: DataChangedService,
    private sensorService: SensorsService
  ) {}

  ngOnInit(): void {
    this.editMode = this.data?.guid !== undefined;
    this.roleBatteryForm = this.formBuilder.group({
      guid: [this.data?.guid ? this.data.guid : uuid.v4()],
      type: ['role-battery-generic'],
      headline: [
        this.data?.headline ? this.data?.headline : '',
        Validators.required,
      ],
      datasource: ['', Validators.required],
    });

    this.sensorService
      .sensorsProjectRead(this.reportModuleService.currentReport.project)
      .subscribe((sensors) => {
        const filteredSensors = this.filterSensors(sensors);
        this.availableDataSources = filteredSensors;
      });
  }

  private filterSensors(sensors: SensorsSensor[]): SensorsSensor[] {
    return sensors.filter((sensor) => {
      const fields = sensor.available_fields.map((field) => field.identifier);

      return (
        fields.length > 0 &&
        ROLE_BATTERY_FIELDS.every((field) => fields.includes(field))
      );
    });
  }

  public updateOrCreateModule() {
    if (this.roleBatteryForm.valid) {
      this.submitting = true;
      this.reportModuleService
        .addOrEditModuleToReport(
          <RoleBatteryConfig>{
            guid: this.roleBatteryForm.value.guid,
            dataset: this.roleBatteryForm.value.datasource,
            headline: this.roleBatteryForm.value.headline,
            type: this.roleBatteryForm.value.type,
            user_settings: {
              margin_warning: this.data?.user_settings.margin_warning
                ? this.data?.user_settings.margin_warning
                : null,
              measured_margin: this.data?.user_settings.measured_margin
                ? this.data?.user_settings.measured_margin
                : null,
              measuring_date: this.data?.user_settings.measuring_date
                ? this.data?.user_settings.measuring_date
                : null,
            },
          },
          this.editMode
        )
        .subscribe(
          (success) => {
            this.submitting = false;
            this.dialogRef.close();
            this.dataChangedService.configUpdated(
              this.reportModuleService.currentReport.id,
              this.roleBatteryForm.value.guid
            );
          },
          (error) => {
            this.submitting = false;
            console.error(error);
          }
        );
    }
  }
}
